var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 62C13.8792 62 0 48.1208 0 31C0 13.8792 13.8792 0 31 0C48.1208 0 62 13.8792 62 31C62 48.1208 48.1208 62 31 62Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 62C13.8792 62 0 48.1208 0 31C0 13.8792 13.8792 0 31 0C48.1208 0 62 13.8792 62 31C62 48.1208 48.1208 62 31 62Z",
    fill: "#E3E5EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0796 94.6627C46.0415 94.9049 45.949 95.1362 45.7939 95.3511C42.5862 99.824 22.4527 106.566 18.241 106.215C21.582 77.1439 -8.86309 52.396 23.7559 42.8108L33.1425 47.9775L36.4999 47.3762L36.9325 43.2407C41.4734 47.7598 43.5738 53.74 44.3819 62.0628C45.4402 72.9512 43.1548 82.716 46.0796 94.6627Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8838 84.4199C25.0226 86.3081 25.0634 88.033 25.0307 89.6165C20.0082 85.0402 15.2877 79.1852 10.8828 72.8486C8.62735 66.5038 6.58679 60.1345 6.63032 55.6235L24.8838 84.4199Z",
    fill: "#11101A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2561 103.003C25.6731 104.989 20.2099 106.379 18.2401 106.216C21.5811 77.1423 -15.304 52.9766 23.7577 42.8119L33.1416 47.9786L36.5017 47.3746L36.9316 43.2418C38.9286 45.2306 40.455 47.5025 41.6058 50.1307L41.3392 50.4245C38.8878 49.6491 37.6036 48.656 36.3385 49.2138C35.2964 49.6736 34.1047 51.3142 33.7402 53.9152C32.2601 53.5425 29.4387 52.4814 27.9695 52.0624C33.4082 60.1702 38.4797 77.5939 34.6734 95.793C34.2 98.0539 32.2764 100.669 31.2561 103.003Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39178 50.6008C7.95918 51.2157 7.42864 52.0537 6.97971 52.9243C3.50532 59.6582 -0.140477 73.2047 -0.953979 81.503C-1.15259 83.5626 -1.61784 84.6564 -1.44643 86.0004C-1.09274 88.7429 5.60846 85.3447 8.22037 87.135C10.7371 81.6445 12.0866 76.0479 18.6925 64.2943C21.0541 60.0908 15.7405 47.2869 8.39178 50.6008Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4534 47.5318C35.6819 46.9441 35.8016 45.7306 36.0519 44.675C36.2723 43.7282 36.626 42.931 36.8382 42.4494C38.1306 42.6126 38.6938 46.5115 39.7902 48.8132C38.0925 47.6297 37.3552 47.529 35.4534 47.5318Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4194 39.4161C23.1609 43.587 31.0755 46.4846 35.4913 47.5348C34.3867 48.8734 32.9529 50.5548 33.01 51.8907C29.824 51.0201 24.4233 49.5209 22.2331 45.448C20.7367 42.6646 21.9665 40.5261 23.4194 39.4161Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3098 43.8335C36.454 43.4335 36.6173 43.0336 36.7778 42.6037C37.2267 41.3766 37.2431 38.7783 38.0266 35.8998L26.692 30.9616L24.2651 29.672C25.1412 33.9436 24.627 36.4902 23.4162 39.5211C23.2938 43.6213 31.067 46.4753 35.4555 47.5255C35.8473 46.5325 35.8718 45.0741 36.3098 43.8335Z",
    fill: "#E8A476"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.453 42.1528C28.5668 40.7 31.78 42.5065 37.1099 41.0809C37.314 39.7232 37.4881 37.8786 38.0268 35.9006L26.6922 30.9597L24.2653 29.6728C25.1413 33.9416 24.6244 36.4883 23.4164 39.5192C23.3865 40.466 23.7783 41.3475 24.453 42.1528Z",
    fill: "#DB9669"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0398 40.3063C34.5543 39.7105 31.1533 38.7637 29.8038 38.1406C26.8545 36.783 26.6314 34.0921 25.1214 30.4817C22.3708 29.2574 21.2852 28.063 20.7574 26.5666C19.5004 23.0187 20.7764 18.6601 23.1244 15.9366C25.1786 13.5614 27.8748 12.4622 31.1669 12.5085C37.5688 12.5983 41.0378 16.7148 42.4444 21.9467C42.5641 22.3957 42.5886 22.8174 42.5396 23.2962C42.4281 24.4308 42.0635 24.9967 41.9764 25.7694C41.8159 27.1515 42.3601 27.3148 42.6457 28.0847C43.0103 29.0588 42.6104 31.0803 42.7029 32.9467C42.7246 33.3956 42.6757 34.0731 42.5614 35.1832C42.3737 37.0578 41.8078 39.2072 41.1983 39.6017C40.6705 39.9499 40.091 40.0805 39.2584 40.4315C38.5973 40.709 37.9334 40.8178 36.0398 40.3063Z",
    fill: "#F1B287"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0398 40.3063C34.5543 39.7105 31.1533 38.7637 29.8038 38.1433C26.8545 36.783 26.6314 34.0921 25.1214 30.4817C22.3708 29.2574 21.2852 28.063 20.7574 26.5666C19.5004 23.0187 20.7764 18.6601 23.1244 15.9366C25.1786 13.5614 27.8748 12.4622 31.1669 12.5085C36.7281 12.5874 40.0746 15.7054 41.7806 19.9524C41.6418 20.3089 38.668 22.0719 35.7405 22.8228C33.8713 23.299 32.6824 22.5453 30.7942 22.1018C30.6527 23.6744 32.3341 27.176 32.4511 28.2398C32.4783 28.4956 31.8145 29.7498 32.5872 30.713C32.7994 30.9769 33.3354 31.2517 33.2918 31.7441C32.8456 36.8537 36.4234 39.3051 38.132 40.6655C37.6423 40.6655 37.0002 40.5675 36.0398 40.3063Z",
    fill: "#E8A476"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2388 21.564C32.6472 20.9736 30.2937 17.8991 27.7036 16.7972C25.0509 15.6708 22.1587 14.4819 20.2868 16.3048C18.7632 18.7561 18.7142 22.8481 19.3536 25.0547C20.2705 28.2135 22.7219 30.7791 25.897 33.4074C27.0914 34.395 26.433 29.8459 26.6588 28.8528C27.0016 29.5493 27.3934 30.2649 27.7961 31.0104L28.6042 30.5397C28.4736 29.631 27.2683 20.3804 27.6981 19.6676C28.6667 19.1996 30.7699 20.7858 34.2388 21.564Z",
    fill: "#361D07"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2621 27.1464C22.7372 26.5723 23.0148 29.3883 23.5698 31.0561C23.9534 32.2015 24.9138 32.0111 25.3628 32.9007C25.8933 33.9591 26.8047 34.3836 27.5339 34.2883C29.0113 34.0924 27.8658 31.9839 27.5965 31.1268C27.6183 29.6739 26.8646 27.5109 25.2621 27.1464Z",
    fill: "#E8A476"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2274 16.5501C19.4601 17.5133 18.7609 19.951 19.0139 21.5073C19.0901 20.3836 19.1962 19.3117 20.2818 18.3703C19.6261 20.0109 19.4955 20.7482 19.9716 22.5847C19.9607 21.1971 20.2464 19.7878 21.3592 18.9498C20.3307 21.2135 20.6681 23.7329 21.1878 25.0035C20.9402 22.952 21.5224 20.6285 22.891 19.4341C22.1373 21.0638 22.6379 22.7861 22.9127 24.2743C23.1059 22.2337 23.0787 21.1291 24.4255 19.9538C24.1017 21.7658 24.5316 23.6458 25.2145 24.8321C25.0703 24.1736 25.4893 21.2325 25.9192 20.2394C26.0497 21.4039 26.7653 22.4732 27.5407 22.9275C27.3067 21.3604 27.2741 20.3456 27.4237 19.5593C27.489 19.211 28.1529 19.1756 28.6698 19.0505C25.1954 18.3676 21.2123 16.6263 20.2274 16.5501Z",
    fill: "#4F2B0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1367 16.5262C23.758 13.8354 28.133 19.7802 33.0684 21.3229C35.1661 21.9786 36.0367 21.701 38.8282 20.5366C40.5804 19.8047 42.1231 18.8851 42.2917 18.0444C43.2277 13.3184 41.3912 11.7785 38.4147 11.0303C37.2012 10.7283 35.5851 10.8398 34.2275 10.4753C28.7479 9.01421 21.8562 10.0454 20.1367 16.5262Z",
    fill: "#361D07"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9318 14.5547C20.3686 15.341 20.2136 15.9804 20.1428 16.6443C23.8893 18.6957 25.3694 18.3747 28.8438 19.6208C32.0134 20.758 35.2811 22.4884 38.0916 20.3744C36.2224 16.5327 34.0703 15.2404 29.4178 15.5152C27.6793 15.6158 26.9284 16.4756 23.3397 15.9178C23.7451 15.7464 24.2375 15.5995 24.662 15.5995C22.7466 15.1778 21.4542 15.6131 20.9318 14.5547Z",
    fill: "#241304"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1628 11.5818C36.3265 9.63919 30.077 10.2296 26.3142 16.9253C30.213 15.9377 31.7639 17.026 33.5133 19.4856C33.9296 20.076 35.1702 21.031 36.2993 21.1207C37.6189 21.2268 38.8704 20.6228 40.5355 19.7957C41.4932 19.3196 42.3802 18.7972 42.7992 17.9674C43.7868 16.0085 43.1529 13.0973 40.1628 11.5818Z",
    fill: "#4F2B0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5317 12.0174C38.4661 12.099 39.987 12.5942 41.4345 14.3708C40.0224 13.375 39.549 13.239 37.8485 13.0866C38.6892 13.4131 39.7068 13.8648 40.6074 15.1435C38.6294 14.1967 37.4921 13.5709 35.1115 13.6144C36.7031 13.9192 37.9492 14.4579 39.0375 15.7421C36.7711 14.7762 34.5292 13.6036 31.803 14.4824C33.9198 14.1912 36.9398 15.6305 38.3573 17.3718C37.0976 16.7868 35.6801 16.2998 34.1701 16.2046C35.272 16.3814 36.3385 18.1799 36.6378 18.5363C34.8829 17.6847 32.992 15.6332 30.157 15.9815C33.5443 16.5148 35.6338 21.9753 38.0662 20.887C39.383 20.2993 42.1827 18.9934 42.6915 18.1472C43.943 16.0713 43.0588 13.658 41.127 12.5125C39.8564 11.7562 37.9546 11.7779 36.5317 12.0174Z",
    fill: "#361D07"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0386 52.1723L64.379 65.1203L46.1228 100.77L70.4735 86.2714L88.0386 52.1723Z",
    fill: "#380303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7438 52.9774L64.7154 65.6071L47.3298 99.6436L48.6929 100.343L89.3517 53.3555L87.7438 52.9774Z",
    fill: "#E3E5EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9168 52.6613L66.1021 66.0201L47.9983 101.259L72.349 86.7603L89.9168 52.6613Z",
    fill: "#380303"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/maleIcon.34c2357928dec972e58029391cd34e32.svg";
export { ForwardRef as ReactComponent };